var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import CheckSvg from './check.svg';
import OpenArrowSvg from './open-arrow.svg';
import AddPlusSvg from './add-plus.svg';
import MotivationSvg from './motivation.svg';
import DownloadSvg from './download.svg';
import WebinarSvg from './webinar.svg';
import ReportSvg from './report.svg';
import TechSvg from './tech.svg';
import GotoSvg from './goto.svg';
import CopiedSvg from './copied.svg';
import PlaySvg from './play.svg';
import CbArrowSvg from './cb-arrow.svg';
import SearchSvg from './search.svg';
import PlayPrimarySvg from './play-primary.svg';
import IntroSvg from './intro.svg';
import DownloadBoldSvg from './download-bold.svg';
export var CheckIcon = function (props) {
    return _jsx(CheckSvg, __assign({}, props), void 0);
};
export var OpenArrowIcon = function (props) {
    return _jsx(OpenArrowSvg, __assign({}, props), void 0);
};
export var AddPlusIcon = function (props) {
    return _jsx(AddPlusSvg, __assign({}, props), void 0);
};
export var MotivationIcon = function (props) {
    return _jsx(MotivationSvg, __assign({}, props), void 0);
};
export var DownloadIcon = function (props) {
    return _jsx(DownloadSvg, __assign({}, props), void 0);
};
export var WebinarIcon = function (props) {
    return _jsx(WebinarSvg, __assign({}, props), void 0);
};
export var ReportIcon = function (props) {
    return _jsx(ReportSvg, __assign({}, props), void 0);
};
export var TechIcon = function (props) {
    return _jsx(TechSvg, __assign({}, props), void 0);
};
export var GotoIcon = function (props) {
    return _jsx(GotoSvg, __assign({}, props), void 0);
};
export var CopiedIcon = function (props) {
    return _jsx(CopiedSvg, __assign({}, props), void 0);
};
export var PlayIcon = function (props) {
    return _jsx(PlaySvg, __assign({}, props), void 0);
};
export var CbArrowIcon = function (props) {
    return _jsx(CbArrowSvg, __assign({}, props), void 0);
};
export var SearchIcon = function (props) {
    return _jsx(SearchSvg, __assign({}, props), void 0);
};
export var PlayPrimaryIcon = function (props) {
    return _jsx(PlayPrimarySvg, __assign({}, props), void 0);
};
export var IntroIcon = function (props) {
    return _jsx(IntroSvg, __assign({}, props), void 0);
};
export var DownloadBoldIcon = function (props) {
    return _jsx(DownloadBoldSvg, __assign({}, props), void 0);
};
